var _defs, _style, _use, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2040 98",
    width: 2040,
    height: 98,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 1631,
    height: 500,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABl8AAAH0AQMAAACJm6lsAAAAAXNSR0IB2cksfwAAAANQTFRF/xg4s/sp8AAAAjFJREFUeJztzwEJADAMwLDPv+mbGDycRkE75yPzOmBTM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqmZUzaiaUTWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6pmVM2omlE1o2pG1YyqGVUzqgtxRQH1kO62bAAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#6880f8}.b{opacity:.4;fill:#fff}")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: -254
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1404.6-239.9l312.4 201.9-271.1 419.6-312.5-201.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m2415-704.4v1378.8h-1149v-1378.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m2040 65v33h-2040v-33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.9f5c8435b83bbcd6378d70e01d288953.svg";
export { ForwardRef as ReactComponent };